module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[100]587.41fa755.woff2";